export const stylesByLevel = (
  level: "h1" | "h2" | "h3" | "h4" | "h5" | "h6",
) => {
  switch (level) {
    case "h1":
      return {
        ml: 0,
        fontSize: "14px",
      };
    case "h2":
      return {
        ml: "1",
        fontSize: "14px",
      };
    case "h3":
      return {
        ml: "2",
        fontSize: "12px",
      };
    case "h4":
      return {
        ml: "3",
        fontSize: "10px",
      };
    case "h5":
      return {
        ml: "4",
        fontSize: "10px",
      };
    default:
      return {
        ml: 0,
        fontSize: "14px",
      };
  }
};
